export enum AudioClips
{
  UI_CLICK = "ui_click",

  CANNON_SHOT = "cannon_shot",

  TEN_SHOTS_SINGLE = "ten_shots_single",
  BIG_SHOT = "big_shot",
  BIG_SHOT_HIT = "big_shot_hit",
  BOOSTER_APPEAR = "booster_appear",
  INFINITE_SHOTS_MUSIC = "infinite_shots_music",
  ROCKET_FLY = "rocket_fly",
  ROCKET_HIT = "rocket_hit",
  ROCKET_LAUNCH = "rocket_launch",

  COINS_GROUP_FLY = "coins_group_fly",

  MAIN_MUSIC = "main_music",
  ADVENTURE_MUSIC = "adventure_music",

  GLASS_CUBE_DROP_1 = "glass_cube_drop_1",
  GLASS_CUBE_DROP_2 = "glass_cube_drop_2",
  GLASS_CUBE_HIT = "glass_cube_hit",
  METAL_CUBE_DROP_1 = "metal_cube_drop_1",
  METAL_CUBE_DROP_2 = "metal_cube_drop_2",
  METAL_CUBE_HIT = "metal_cube_hit",
  WOOD_CUBE_DROP_1 = "wood_cube_drop_1",
  WOOD_CUBE_DROP_2 = "wood_cube_drop_2",
  WOOD_CUBE_HIT = "wood_cube_hit",

  LOSE_GAME = "lose_game",
  SEARCH_LEVEL = "search_level",
  START_LEVEL = "start_level",
  WIN_GAME = "win_game",
  WIN_GAME_LOOP = "win_game_loop",
  MUSIC_1 = "music_1",
  MUSIC_2 = "music_2",
  MUSIC_3 = "music_3",
  MUSIC_4 = "music_4",
}


export const AUDIO_PATHS: Record<AudioClips, string> = {
  [AudioClips.UI_CLICK]: "assets/sounds/UI_CLICK.wav",

  [AudioClips.CANNON_SHOT]: "assets/sounds/CANNON.mp3",
  [AudioClips.TEN_SHOTS_SINGLE]: "assets/sounds/booster_sounds/10_SHOTS_SINGLE.mp3",
  [AudioClips.BIG_SHOT]: "assets/sounds/booster_sounds/BIG_SHOT.mp3",
  [AudioClips.BIG_SHOT_HIT]: "assets/sounds/booster_sounds/BIG_SHOT_HIT.mp3",
  [AudioClips.BOOSTER_APPEAR]: "assets/sounds/booster_sounds/BOOSTER_APPEAR.mp3",
  [AudioClips.INFINITE_SHOTS_MUSIC]: "assets/sounds/booster_sounds/INFINITE_SHOTS_MUSIC_5_SEC.mp3",
  [AudioClips.ROCKET_FLY]: "assets/sounds/booster_sounds/ROCKET_FLY.mp3",
  [AudioClips.ROCKET_HIT]: "assets/sounds/booster_sounds/ROCKET_HIT.mp3",
  [AudioClips.ROCKET_LAUNCH]: "assets/sounds/booster_sounds/ROCKET_LAUNCH.mp3",
  
  [AudioClips.COINS_GROUP_FLY]: "assets/sounds/COINS_GROUP_FLY.mp3",

  [AudioClips.LOSE_GAME]: "assets/sounds/LOSE_GAME.mp3",
  [AudioClips.SEARCH_LEVEL]: "assets/sounds/SEARCH_LEVEL.mp3",
  [AudioClips.START_LEVEL]: "assets/sounds/START_LEVEL.mp3",
  [AudioClips.WIN_GAME]: "assets/sounds/WIN_GAME.mp3",
  [AudioClips.WIN_GAME_LOOP]: "assets/sounds/WIN_SHORT_LOOP.mp3",

  [AudioClips.MAIN_MUSIC]: "assets/sounds/MUSIC_LOOP_5_RAIN.mp3",
  [AudioClips.ADVENTURE_MUSIC]: "assets/sounds/MUSIC_LOOP_6_24s.mp3",

  [AudioClips.GLASS_CUBE_DROP_1]: "assets/sounds/GLASS_CUBE_DROP_1.mp3",
  [AudioClips.GLASS_CUBE_DROP_2]: "assets/sounds/GLASS_CUBE_DROP_2.mp3",
  [AudioClips.GLASS_CUBE_HIT]: "assets/sounds/GLASS_CUBE_HIT.mp3",
  [AudioClips.METAL_CUBE_DROP_1]: "assets/sounds/METAL_CUBE_DROP_1.mp3",
  [AudioClips.METAL_CUBE_DROP_2]: "assets/sounds/METAL_CUBE_DROP_2.mp3",
  [AudioClips.METAL_CUBE_HIT]: "assets/sounds/METAL_CUBE_HIT.mp3",
  [AudioClips.WOOD_CUBE_DROP_1]: "assets/sounds/WOOD_CUBE_DROP_1.mp3",
  [AudioClips.WOOD_CUBE_DROP_2]: "assets/sounds/WOOD_CUBE_DROP_2.mp3",
  [AudioClips.WOOD_CUBE_HIT]: "assets/sounds/WOOD_CUBE_HIT.mp3",

  [AudioClips.MUSIC_1]: "assets/sounds/MUSIC_1.mp3",
  [AudioClips.MUSIC_2]: "assets/sounds/MUSIC_2_)).mp3",
  [AudioClips.MUSIC_3]: "assets/sounds/MUSIC_3_LOOP.mp3",
  [AudioClips.MUSIC_4]: "assets/sounds/MUSIC_4_LOOP.mp3",
};
